import React, { useState } from "react";
import styled from "styled-components";
import { MdUploadFile } from "react-icons/md";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { UiConstants } from "../../data/UiConstants";
const HiddenInput = styled.input.withConfig({
  displayName: "FileUploadButton__HiddenInput",
  componentId: "sc-3p7wud-0"
})(["display:none;"]);
const InputContent = styled.label.withConfig({
  displayName: "FileUploadButton__InputContent",
  componentId: "sc-3p7wud-1"
})(["cursor:pointer;background-color:#BBBBBB;&:hover{background-color:", ";}border:solid black 1px;display:flex;align-items:center;padding-top:2px;padding-right:4px;margin:2px;border-radius:", ";"], UiConstants.COLOR_HOVER, UiConstants.BORDER_RADIUS);
const UploadIcon = styled(MdUploadFile).withConfig({
  displayName: "FileUploadButton__UploadIcon",
  componentId: "sc-3p7wud-2"
})(["cursor:pointer;margin-bottom:2px;margin-right:4px;margin-left:2px;"]);
const CheckIcon = styled(AiOutlineCheckCircle).withConfig({
  displayName: "FileUploadButton__CheckIcon",
  componentId: "sc-3p7wud-3"
})(["color:green;cursor:pointer;margin-bottom:2px;margin-right:4px;margin-left:2px;"]);
let idCounter = 0;
export const FileUploadButton = ({
  onFileSelected,
  acceptMimeType,
  labelText
}) => {
  const [jsonInputId] = useState(() => 'file-selector-' + idCounter++);
  const [selectedFile, setSelectedFile] = useState("");

  function onSelect(e) {
    const file = e.target.files[0];
    setSelectedFile(file.name);
    onFileSelected(file);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HiddenInput, {
    id: jsonInputId,
    type: "file",
    accept: acceptMimeType,
    onChange: onSelect
  }), /*#__PURE__*/React.createElement(InputContent, {
    htmlFor: jsonInputId
  }, !selectedFile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UploadIcon, {
    size: 24
  }), " ", labelText), selectedFile && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CheckIcon, {
    size: 24
  }), " ", selectedFile)));
};